/**
 * Common PromotionalCard component used by other modules as a reusable component which returns the ui for a promo card or a product card compact.
 *
 * @module views/components/PromotionalCard
 * @memberof -Common
 */
import './PromotionalCard.scss';

import React from 'react';

import PropTypes from 'prop-types';

import { spreadProps } from '@ulta/core/utils/dom/dom';

import PromoCard from '../PromoCard/PromoCard';
import PromoCardCompact from '../PromoCardCompact/PromoCardCompact';

/**
 * Represents a ProductRail component
 *
 * @method
 * @param {PromotionalCardProps} props - React properties passed from composition
 * @returns nProductRail
 */
const PromotionalCard = function( props ){
  const { variant = PROMO_CARD_COMPACT } = props;

  const CardComponent = variant === PROMO_CARD_COMPACT ? PromoCardCompact : PromoCard;

  return (
    <div className='PromotionalCard'>
      <CardComponent { ...spreadProps( props ) } />
    </div>
  );
};

/**
 * @const {string} PROMO_CARD_REGULAR - option for regular pormo card
 */
export const PROMO_CARD_REGULAR = 'Regular';

/**
 * @const {string} PROMO_CARD_COMPACT - option for compact promo card
 */
export const PROMO_CARD_COMPACT = 'Compact';

/**
 * Property type definitions
 *
 * @typedef PromoCardProps
 * @type {object}
 * @property {string} alignment - sets the alignment for PromoCard component
 * @property {string} backgroundColor - Sets the backgroundColor for card
 * @property {string} disclaimer - Sets the disclaimer
 * @property {string} highlight - Sets the highlight
 * @property {object} image - Sets the image for promotional card
 * @property {object} linkAction - Sets the linkAction
 * @property {string} listPrice - Sets the listPrice
 * @property {string} salePrice - Sets the salePrice
 * @property {string} supportingText - Sets the titleSupport
 * @property {string} title - Sets the title
 * @property {string} variant - Sets the variant of promotional card
 */
export const propTypes =  {
  alignment: PropTypes.oneOf( ['top', 'bottom', 'vertical'] ),
  backgroundColor: PropTypes.string,
  disclaimer: PropTypes.string,
  highlight: PropTypes.string,
  image: PropTypes.object,
  linkAction: PropTypes.object,
  listPrice: PropTypes.string,
  salePrice: PropTypes.string,
  supportingText: PropTypes.string,
  title: PropTypes.string,
  variant: PropTypes.oneOf( ['Regular', 'Compact'] ),
  tags: PropTypes.array,
  originalPriceLabel: PropTypes.string
};

PromotionalCard.propTypes = propTypes;

export default PromotionalCard;
